<div class="" fxLayout="column" fxLayoutAlign="start stretch">


    <ng-container *ngIf="!creandoEncuesta">
      <ng-container *ngIf="seccionEncuesta">
        <div *ngIf="procesoFinalizado && procesoOK; else procFallido;" class="" fxLayout="row" fxLayoutAlign="space-evenly center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div class="roundEdg done mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'SHEDULE2_0.ENCUESTACREADA' | translate}}</h2>
            <mat-icon class="ml-20 s-30">check_circle</mat-icon>
          </div>
          <button mat-raised-button color="primary" class="wsn done" (click)="verSeccionesAgregadas()">
            {{'SHEDULE2_0.VERSECCIONES' | translate}}
            <mat-icon class="ml-20">format_list_numbered</mat-icon>
          </button>

          <button mat-raised-button color="primary" class="wsn done" (click)="surveyCheckService()">
            {{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}
            <mat-icon class="ml-20">check_circle</mat-icon>
          </button>
        </div>
        <ng-template #procFallido>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="roundEdg fail mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
              <h2>{{'SHEDULE2_0.ENCUESTAERROR' | translate}}</h2>
              <mat-icon class="ml-20 s-30">close</mat-icon>
            </div>
            <button mat-raised-button color="primary" class="wsn done" (click)="verSeccionesAgregadas()">
              {{'SHEDULE2_0.VERSECCIONES' | translate}}
              <mat-icon class="ml-20">format_list_numbered</mat-icon>
            </button>
          </div>
        </ng-template>
      </ng-container>
      <div fxLayout="row wrap" fxLayoutAlign="space-evenly start" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div *ngFor="let card of cards; let i = index;" class="course-content m-20" fxLayout="column" fxFlex="100" fxFlex.gt-xs="40" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
            <div class="category" fxFlex>
              {{card.titulo | translate}}
            </div>
          </div>
          <div class="content m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">

            <ng-container *ngIf="i == 0">
              <ng-container *ngIf="card.completo == false; else card1Ok">
                <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_PRE' | translate}}</p>
                <mat-list>
                  <mat-list-item>
                    <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                    <button *ngIf="!banderaRTV3" mat-mini-fab color="accent" routerLink="{{urlRequerimientosV3}}" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.REQTEC_TOOLTIP' | translate}}" matTooltipPosition="right">
                      <mat-icon>send</mat-icon>
                    </button>
                    <div *ngIf="banderaRTV3" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-icon class="s-20">done</mat-icon>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                  <mat-list-item>
                    <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                    <button *ngIf="!logoOK" mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.LOGO_TOOLTIP' | translate}}" matTooltipPosition="right" (click)="cargaLogoEmpresa()">
                      <mat-icon>add_a_photo</mat-icon>
                    </button>
                    <div *ngIf="logoOK" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-icon class="s-20">done</mat-icon>
                    </div>
                  </mat-list-item>
                </mat-list>
              </ng-container>
              <ng-template #card1Ok>
                <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_POST' | translate}}</p>
                <mat-list>
                  <mat-list-item>
                    <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                    <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-icon class="s-20">done</mat-icon>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                  <mat-list-item>
                    <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                    <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-icon class="s-20">done</mat-icon>
                    </div>
                  </mat-list-item>
                </mat-list>
              </ng-template>

              <!-- <mat-list *ngIf="validationUser">
                <mat-list-item>
                  <mat-divider></mat-divider>
                  <button mat-raised-button (click)="navegaEdicionEnucuesta()" [disabled]="pasoCompleto">
                    {{'EDITOR.ELEMENTOS.BOTONES.ENTRAR' | translate}}
                    <mat-icon class="ml-20">edit</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Más información" matTooltipPosition="right" class="ml-10" (click)="infoEdicionEncuesta()">
                    <mat-icon>help_outline</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list> -->
            </ng-container>

            <ng-container *ngIf="i == 1">
              <ng-container *ngIf="!preReqOK; else paso2Ok">
                <p>{{'SHEDULE2_0.CARDS.PASO7.INFO_PRE' | translate}}</p>
              </ng-container>
              <ng-template #paso2Ok>
                <input #imagen type="file" (change)="openCropperDialog($event)" accept="image/*" hidden>
                <p *ngIf="!card.completo" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">{{'SHEDULE2_0.CARDS.PASO7.INFO_POST_1' | translate}}</p>
                <p *ngIf="card.completo" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">{{'SHEDULE2_0.CARDS.PASO7.INFO_POST_2' | translate}}</p>
                <mat-list class="w90" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" *ngIf="jsonLogos">
                  <mat-list-item class="hta">
                    <div fxFlex fxLayout="column" fxLayoutAlign="start center">
                      <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO7.EMPRESA' | translate}}</p>
                      <div fxLayout="row">
                        <button mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO7.PREVIEW' | translate}}" matTooltipPosition="below" [disabled]="jsonLogos.logos.company.image == ''" (click)="zoomImagen(jsonLogos.logos.company.image,1)">
                          <mat-icon>zoom_in</mat-icon>
                        </button>
                        <button class="ml-20" mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO7.CAMBIAR' | translate}}" matTooltipPosition="below" (click)="imagen.click(); tipoLogoCargado = 1;">
                          <mat-icon>import_export</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div class="roundEdg mat-elevation-z4 p-5 mt-10 mb-10" [ngClass]="{'undone':jsonLogos.logos.company.set == false, 'done':jsonLogos.logos.company.set == true}" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-icon class="s-20" *ngIf="!jsonLogos.logos.company.set">more_horiz</mat-icon>
                      <mat-icon class="s-20" *ngIf="jsonLogos.logos.company.set">done</mat-icon>
                    </div>
                  </mat-list-item>
                  <ng-container *ngIf="card.visibleCertificado">
                    <mat-divider class="mb-20 mt-20"></mat-divider>
                    <mat-list-item class="hta">
                      <div fxFlex fxLayout="column" fxLayoutAlign="start center">
                        <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO7.CERTIFICADO' | translate}}</p>
                        <div fxLayout="row">
                          <button mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO7.PREVIEW' | translate}}" matTooltipPosition="below" [disabled]="jsonLogos.logos.certificate.image == ''" (click)="zoomCertificado(jsonLogos.logos.certificate.image)">
                            <mat-icon>zoom_in</mat-icon>
                          </button>
                          <button class="ml-20" mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO7.CAMBIAR' | translate}}" matTooltipPosition="below" (click)="imagen.click(); tipoLogoCargado = 2;">
                            <mat-icon>import_export</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div class="roundEdg mat-elevation-z4 p-5 mt-10 mb-10" [ngClass]="{'undone':jsonLogos.logos.certificate.set == false, 'done':jsonLogos.logos.certificate.set == true}" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <mat-icon class="s-20" *ngIf="!jsonLogos.logos.certificate.set">more_horiz</mat-icon>
                        <mat-icon class="s-20" *ngIf="jsonLogos.logos.certificate.set">done</mat-icon>
                      </div>
                    </mat-list-item>
                  </ng-container>
                  <ng-container *ngIf="validationUser">
                    <mat-divider class="mb-20 mt-20"></mat-divider>
                    <mat-list-item class="hta">
                      <div fxFlex fxLayout="column" fxLayoutAlign="start center">
                        <button mat-raised-button class="botSurvEd" (click)="navegaEdicionEnucuesta()" [disabled]="pasoCompleto">
                          {{'EDITOR.ELEMENTOS.BOTONES.ENTRAR' | translate}}
                          <!-- <mat-icon class="ml-20">edit</mat-icon> -->
                        </button>
                      </div>
                      <button mat-icon-button matTooltip="Más información" matTooltipPosition="right" class="ml-10" (click)="infoEdicionEncuesta()">
                        <mat-icon>help_outline</mat-icon>
                      </button>
                    </mat-list-item>
                  </ng-container>
                </mat-list>
              </ng-template>
            </ng-container>

            <!-- <ng-container *ngIf="i == 1 && SurveyGeneration">
              <ng-container *ngIf="mostrarHistorial">
                <p>{{'SHEDULE2_0.CARDS.PASO6.INFO_PRE' | translate}}</p>
                <p style="font-weight:Bold">{{fechaUltimaCreacion.createdAt |date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{fechaUltimaCreacion.createdAt |date:'O':offsetPipe:idiomaActual}})</p>
                <mat-expansion-panel class="mb-20 accent-50">
                  <mat-expansion-panel-header>
                    <mat-panel-title style="font-weight:Book; padding-left:20px; text-align:center">
                      {{'SHEDULE2_0.CARDS.PASO6.INFO_PRE_2' | translate}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-list>
                    <mat-list-item *ngFor="let histoGeneration of historySurveyGeneration  let y = index">
                      <p class="fz14 mr-20" style="color:#C9CACD">{{y}}) {{histoGeneration.createdAt |date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{histoGeneration.createdAt |date:'O':offsetPipe:idiomaActual}})</p>
                      <mat-divider></mat-divider>
                    </mat-list-item>
                  </mat-list>
                </mat-expansion-panel>
              </ng-container>
              <ng-container *ngIf="!mostrarHistorial">
                <h3>Aún no hay historial</h3>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="i == 1 && !SurveyGeneration">
              <h3>{{'SHEDULE2_0.CARDS.PASO6.ERRORHISTORIAL' | translate}}</h3>
            </ng-container> -->

          </div>
          <div class="footer" fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container *ngIf="card.completo == false">
              <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.PENDING' | translate}}</b></div>
              <div class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                <mat-icon class="s-20">priority_high</mat-icon>
              </div>
            </ng-container>
            <ng-container *ngIf="card.completo == true">
              <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.OK' | translate}}</b></div>
              <div class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                <mat-icon class="s-20">done</mat-icon>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="p-20 mb-70" fxLayout="row" fxLayoutAlign="space-between center">
        <button *ngIf="!pasoCompleto" mat-raised-button color="primary" class="wsn" (click)="preCrearEncuesta()" [fxFlex]="seccionEncuesta == true ? 48 : 100">
          <ng-container *ngIf="recrearEncuestaBtn; else botCrear;">
            {{'SHEDULE2_0.RECREAR' | translate}}
          </ng-container>
          <ng-template #botCrear>
            {{'SHEDULE2_0.CREAR' | translate}}
          </ng-template>
          <mat-icon class="ml-20">play_arrow</mat-icon>
        </button>
        <button mat-raised-button color="accent" class="wsn" fxFlex="48" *ngIf="seccionEncuesta" (click)="verHistorialCreacion()">
          {{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.BOTON' | translate}}
          <mat-icon class="ml-20">history</mat-icon>
        </button>
      </div>

    </ng-container>


    <div *ngIf="creandoEncuesta" class="tac" fxLayout="column" fxLayoutAlign="start stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div *ngIf="procesoFinalizado || recrearEncuesta" fxLayout="row" fxLayoutAlign="start center" class="mt-20">
            <button mat-raised-button color="accent" (click)="verSeccionesAgregadas();getHistrialCreacionEncuesta()">
        <mat-icon class="mr-20">arrow_back</mat-icon>
        {{'SHEDULE2_0.BACK' | translate}}
      </button>
        </div>
        <h3 *ngIf="!procesoFinalizado && !procesoOK" class="mb-20">{{'SHEDULE2_0.CREANDO' | translate}}</h3>
        <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
            <ng-container *ngFor="let seccion of secciones">
                <div *ngIf="seccion.visible" fxFlex="{{tamanioTagSecc}}" fxLayout="column" fxLayoutAlign="space-between center">
                    <!-- <div class="roundEdg iconoSeccion mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center"> -->
                    <div class="p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon class="s-30">{{seccion.icono}}</mat-icon>
                    </div>
                    <b>{{seccion.titulo | translate}}</b>
                    <div *ngIf="!seccion.completo && !seccion.fallo" class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </div>
                    <div *ngIf="seccion.completo" class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <mat-icon class="s-20">done</mat-icon>
                    </div>
                    <div *ngIf="!seccion.completo && seccion.fallo" class="roundEdg fail mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <mat-icon class="s-20">close</mat-icon>
                    </div>
                </div>
            </ng-container>
        </div>
        <mat-progress-bar mode="buffer" value="{{progresoEncuesta}}"></mat-progress-bar>
        <h3 *ngIf="procesoActual!= ''" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}"><b>{{procesoActual | translate}}</b></h3>
        <div fxLayout="row" fxLayoutAlign="center center" *ngIf="checarEncuesta">
            <button mat-raised-button color="primary" class="wsn done" (click)="surveyCheckService()" style="width:30%;">
    {{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}
      <mat-icon class="ml-20">check_circle</mat-icon>
    </button>
        </div>
        <div *ngIf="procesoFinalizado && !procesoOK" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}">
      <button mat-raised-button color="accent" class="wsn" (click)="crearEncuesta()">
        {{'SHEDULE2_0.RETRY' | translate}}
        <mat-icon class="ml-20">replay</mat-icon>
      </button>
    </div>
    </div>

</div>
<!-- <div *ngIf="procesoFinalizado && procesoOK" fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
  <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>done</mat-icon>
  </button>
  <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
    {{'SHEDULE.PASO_COMPLETADO' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
</div> -->
